<template>
  <div id="app">
    <div class="content vivify fadeIn">
      <img class="vivify popIn" src="@/assets/image/home/home1.jpg" alt="" />
    </div>
    <div class="content2 vivify fadeIn">
      <div class="content2-box">
        <p class="header vivify popIn">INTRODUCTION</p>
        <p class="vivify popIn">India’s textiles sector is one of the oldest industries in the Indian economy, dating back to several centuries. The industry is extremely varied, with hand-spun and hand-woven textiles sectors at one end of the spectrum, with the capital-intensive sophisticated mills sector at the other end. The fundamental strength of the textile industry in India is its strong production base of a wide range of fibre/yarns from natural fibres like cotton, jute, silk and wool, to synthetic/man-made fibres like polyester, viscose, nylon and acrylic.</p>
        <p class="vivify popIn">The decentralised power looms/ hosiery and knitting sector form the largest component of the textiles sector. The close linkage of textiles industry to agriculture (for raw materials such as cotton) and the ancient culture and traditions of the country in terms of textiles makes it unique in comparison to other industries in the country. India’s textiles industry has a capacity to produce a wide variety of products suitable for different market segments, both within India and across the world.</p>
        <p class="vivify popIn">In order to attract private equity and employee more people, the government introduced various schemes such as the Scheme for Integrated Textile Parks (SITP), Technology Upgradation Fund Scheme (TUFS) and Mega Integrated Textile Region and Apparel (MITRA) Park scheme.</p>
      </div>
      <img class="content2-img1 vivify popIn" src="@/assets/image/home/home2.jpg" alt="" />
    </div>
    <div class="product">
      <p class="header">PRODUCT</p>
    </div>
    <div class="content3">
      <div class="content3-info vivify fadeIn">
        <div class="contc driveInLeft">
          <img src="@/assets/image/product/p1.png" alt="" />
        </div>
        <div class="contc driveInTop">
          <img src="@/assets/image/product/p2.png" alt="" />
        </div>
        <div class="contc driveInRight">
          <img src="@/assets/image/product/p3.png" alt="" />
        </div>
        <div class="contc driveInLeft">
          <img src="@/assets/image/product/p4.png" alt="" />
        </div>
        <div class="contc driveInBottom">
          <img src="@/assets/image/product/p5.png" alt="" />      
        </div>
        <div class="contc driveInRight">
          <img src="@/assets/image/product/p6.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>

import '@/assets/css/vivify.min.css'

export default {
  data() {
    return {
    };
  },  
  methods: {
    gotoPay(id) {
      this.$router.push(`/pay/${id}`)
    },
  },
};

</script>
  
<style lang="less" scoped>

@media screen and (min-width: 768px) {
  #app {
    .content {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .content-img{
       margin-top: 2vw;
       width: 100%;
      img {
        width: 100%;
      }
    }
    .product {
      margin-top: 8vw;
      width: 100%;
      text-align: center;
      .header {
        margin-top: 1vh;
        display: inline-block;
        text-align: left;
        color: blue;
        font-size: 2vw;
        font-weight: 600;
      } 
    }
    .content2 {
      position: relative;
      top: 4.375rem;
      display: flex;
      width: 81vw;
      margin-left: 9%;
      .content2-img1 {
        width: 60%;
      }
      .content2-box {
        text-align: left;
        padding: 3.1875rem;
        background-color: #fff;
        .header {
          margin-top: 1vh;
          display: inline-block;
          text-align: left;
          color: red;
          font-size: 2vw;
          font-weight: 600;
        }        
        p {
          margin-top: 1vh;
          display: inline-block;
          text-align: left;
          font-size: 1vw;
          font-weight: 200;
        }
      }
    }
    .content3 {
      text-align: center;
      margin-top: 2vh;
      padding-bottom: 4vh;
      width: 100%;
      .content3-info {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        .contc{
          width: 30%; 
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            margin-top: 2vh;
            width: 25vw;
            height: 25vw;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  #app {
    .content {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .product {
      margin-top: 2vw;
      width: 100%;
      text-align: center;      
      .header {
        margin-top: 1vh;
        display: inline-block;
        text-align: left;
        color: blue;
        font-size: 2vw;
        font-weight: 600;
      } 
    }
    .content2 {
      display: flex;
      width:80vw;
      margin-left: 5%;      
      .content2-img1 {
        width: 45vw;
        height: 45vw;
      }
      .content2-box {
        text-align: left;
        padding: 2vw;
        background-color: #fff;
        height: 40vw;
        .header {
          margin-top: 1vh;
          display: inline-block;
          text-align: left;
          color: red;
          font-size: 2vw;
          font-weight: 600;
        }        
        p {
          margin-top: 1vh;
          display: inline-block;
          text-align: left;
          font-size: 1vw;
          font-weight: 200;
        }
      }
    }
    .content-img{
       margin-top: 2vw;
       width: 100%;
      img {
        width: 100%;
      }
    }
    .content3 {
      margin-top: 2vh;
      padding-bottom: 4vh;
      width: 100%;
      .content3-info {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        .contc{
          width: 50%; 
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            margin-top: 1vh;
            width: 40vw;
            height: 40vw;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/home/index.vue